<h2 mat-dialog-title>{{ "Offene Zusagen" }}</h2>
<mat-dialog-content data-cy="invitee-available-jobs-dialog">
  {{
    data.openJobs.length > 1
      ? ("thereAreXJobsWithOpenInvitations"
        | i18n: { count: data.openJobs.length.toString() })
      : ("thereIsAnOpenInvitationForThisDay" | i18n)
  }}
  {{ "shouldCancelOpenInvitations" | i18n }}
  <div class="jobs-list">
    <div
      *ngFor="let job of data.openJobs"
      class="invitee-available-job-item"
      [class.available]="job.isAvailable"
      [attr.data-cy]="'invitee-available-job-item-' + job._id">
      <div
        class="status-bar"
        [matTooltip]="
          job.isAvailable
            ? ('reportedAvailable' | i18n | titlecase)
            : ('invited' | i18n | titlecase)
        "
        [matTooltipShowDelay]="100"
        matTooltipPosition="above"
        [class.status-has-available-invitees]="job.isAvailable"></div>
      <div class="job-header">
        <div class="job-time">
          <div
            class="job-date"
            data-cy="job-date-info">
            {{ job.date | date: "EEEEEE. dd.MM.yyyy" }}
          </div>
          <div
            class="job-shift"
            *ngFor="let shift of job.shifts">
            <div class="job-shift-tag">
              {{
                shift.label
                  ? shift.label
                  : ("shifts." + shift.shift | i18n | titlecase)
              }}
            </div>
            <div class="job-shift-time">
              {{ shift.from | time }} - {{ shift.to | time }}
            </div>
          </div>
        </div>
        <app-job-list-item-organisation-heading
          [department]="job.department"
          [organisation]="job.organisation"
          class="invitee-available-job-heading">
        </app-job-list-item-organisation-heading>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions
  align="end"
  class="dialog-actions">
  <button
    class="outline-pill-button"
    type="button"
    (click)="cancel()"
    data-cy="cancel-button">
    {{ "cancel" | i18n | titlecase }}
  </button>
  <button
    class="outline-pill-button"
    type="button"
    (click)="keepOpen()"
    data-cy="keep-open-button">
    {{
      data.openJobs.length > 1
        ? ("keepOpenInvitations" | i18n)
        : ("keepOpenInvitation" | i18n)
    }}
  </button>
  <button
    class="primary-pill-button"
    type="button"
    color="primary"
    (click)="cancelJobs()"
    data-cy="cancel-jobs-button">
    {{
      data.openJobs.length > 1
        ? ("cancelOpenInvitations" | i18n)
        : ("cancelOpenInvitation" | i18n)
    }}
  </button>
</mat-dialog-actions>
